(function() {
	if (typeof window.WebBaseAprovLV === 'undefined') {
		window.WebBaseAprovLV = {};
	}
	WebBaseAprovLV.config = {
		projectId: '505985a0-ced9-0184-5d3c-36be71e24187',
		apiUrl: 'https://deliver.kontent.ai/505985a0-ced9-0184-5d3c-36be71e24187',
		apiHeaders: {},
		defaultLang: 'it',
		langId: {
			'de': '00000000-0000-0000-0000-000000000000',
			'it': 'f7ad7e1a-4206-4b85-926b-b955ea74de14'
		},
		environment: 'prod',
		authorities: {
			'de': 'https://csirt-st.provinz.bz.it/',
			'it': 'https://csirt-aa.provincia.bz.it/'
		},
		noovleSearchApiUrl: 'https://api.integrations.services.siag.it/pub/cocweb/quelix/aprov/api/search?',
		noovleSearchCollection: 'coll_lv_cert_aa_st_',
		templatesPath: '/js/templates/',
		cookieiub: {
			siteId: 3247461,
			iub: {
				de: {
					'lang': 'de',
					'cookiePolicyId': 63484381,
					'cookiePolicyUrl': '/de/cookie',
					'privacyPolicyUrl': '/de/privacy'
				},
				it: {
					'lang': 'it',
					'cookiePolicyId': 32435907,
					'cookiePolicyUrl': '/it/cookie',
					'privacyPolicyUrl': '/it/privacy'
				}
			}
		}
	};
})();
